var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon-32-Black-Complete"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6386_338705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6386_338705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 12 Copy",
    d: "M18.4193 6.81983C18.5878 6.63721 18.8725 6.62582 19.0552 6.79439C19.2175 6.94423 19.2445 7.18583 19.1301 7.36592L19.0806 7.43028L10.0806 17.1803C9.9162 17.3584 9.64509 17.3715 9.46475 17.2233L9.40827 17.1679L4.90827 11.9179C4.74653 11.7292 4.76838 11.4451 4.95708 11.2834C5.12481 11.1396 5.36791 11.1409 5.53345 11.2755L5.5916 11.3322L9.76193 16.1978L18.4193 6.81983Z",
    fill: "black",
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e4efbd92a03c8a8fad2d81d05ec0a6f6.svg";
export { ForwardRef as ReactComponent };